export enum AdminPrivilegeEnum {
  UserAdmin = 1,
  ProjectProxy = 3,
  CreateUser = 4,
  UserAdminLight = 5,
  ProjectManager = 6,
  ProjectAdmin = 7,
}
